import { List } from "immutable";

import { autoUpdatesSelectors } from "../autoUpdates";

const getUiStateSettingsModalOpen = state => Boolean(state.getIn(["uiState", "settingsModalOpen"]));
const getUiStatePrintPreviewModalOpen = state => Boolean(state.getIn(["uiState", "printPreviewModalOpen"]));
const getUiStatePreferencesModalOpen = state => Boolean(state.getIn(["uiState", "preferencesModalOpen"]));
const getUiStateSyncSettingsModalOpen = state => Boolean(state.getIn(["uiState", "syncSettingsModalOpen"]));
const getUiStateBackupModalOpen = state => Boolean(state.getIn(["uiState", "backupModalOpen"]));
const getUiStateAboutModalOpen = state => Boolean(state.getIn(["uiState", "aboutModalOpen"]));
const getUiStateExportImagePreviewModalOpen = state => Boolean(state.getIn(["uiState", "exportImagePreviewModalOpen"]));
const getUiStateExportTsfModalOpen = state => Boolean(state.getIn(["uiState", "exportTsfModalOpen"]));
const getUiStateExportCsvModalOpen = state => Boolean(state.getIn(["uiState", "exportCsvModalOpen"]));
const getUiStateImportCsvModalOpen = state => Boolean(state.getIn(["uiState", "importCsvModalOpen"]));
const getSaveTemplateModalOpen = state => Boolean(state.getIn(["uiState", "saveTemplateModalOpen"]));
const getUiStateInspectorModalOpen = state => Boolean(state.getIn(["uiState", "inspectorModalOpen"]));
const getUiStateFileVersionTooLowModalOpen = state => Boolean(state.getIn(["uiState", "fileVersionTooLowModalOpen"]));
const getUiStateOpenFileAllowReadonly = state => Boolean(state.getIn(["uiState", "openFileAllowReadonly"]));

const isModalOpen = state =>
  getUiStateSettingsModalOpen(state) ||
  getUiStatePrintPreviewModalOpen(state) ||
  getUiStatePreferencesModalOpen(state) ||
  getUiStateSyncSettingsModalOpen(state) ||
  getUiStateBackupModalOpen(state) ||
  getUiStateAboutModalOpen(state) ||
  getUiStateExportImagePreviewModalOpen(state) ||
  getUiStateExportTsfModalOpen(state) ||
  getUiStateExportCsvModalOpen(state) ||
  getUiStateImportCsvModalOpen(state) ||
  getUiStateInspectorModalOpen(state) ||
  getUiStateFileVersionTooLowModalOpen(state) ||
  autoUpdatesSelectors.showReleaseNotesModal(state);

const getUiStateSampleModalOpen = state => Boolean(state.getIn(["uiState", "sampleModalOpen"]));

const getUiStateNotification = state => {
  return state.uiState.get("floatingNotification");
};

const getSelectedItems = state => state.getIn(["appState", "selectedItems"]);

const getSelectedSyncItems = state => state.getIn(["appState", "selectedSyncItems"]);
const getSelectedMarkers = state => state.getIn(["appState", "selectedMarkers"]);

const getSavedFiltersExpanded = state => Boolean(state.uiState.get("savedFiltersExpanded"));

const getSearchReplaceExpanded = state => Boolean(state.uiState.get("searchReplaceExpanded"));
const getSearchCaseSensitive = state => Boolean(state.uiState.get("searchCaseSensitive"));
const getSearchWholeWord = state => Boolean(state.uiState.get("searchWholeWord"));
const getSearchValue = state => state.uiState.get("searchValue");
const getReplaceValue = state => state.uiState.get("replaceValue");
const getExcludedSearchFields = state =>
  state.uiState.get("excludeSearchFields") ? state.uiState.get("excludeSearchFields") : List();

const getPulsateIconId = state => state.uiState.pulsateIcon;

const getMenuPopoverType = state => state.getIn(["uiState", "menuPopoverType"]);

const getFileName = state => state.uiState.fileName;

const getIsEditMode = state => state.uiState.isEditMode;
const getIsEntityEditMode = state => state.uiState.isEntityEditMode;
const getDeviceInsets = state => state.uiState.deviceInsets;

const getLeftPanelHasChildPopover = state => state.uiState.leftPanelHasChildPopover;

const getSyncInProgress = state => state.uiState.syncInProgress;
const getSyncProgressLabel = state => state.uiState.syncProgressLabel;
const getSyncProgressPercent = state => state.uiState.syncProgressPercent;

export default {
  getUiStateSettingsModalOpen,
  getUiStatePrintPreviewModalOpen,
  getUiStatePreferencesModalOpen,
  getUiStateSyncSettingsModalOpen,
  getUiStateBackupModalOpen,
  getUiStateAboutModalOpen,
  getUiStateExportImagePreviewModalOpen,
  getUiStateExportTsfModalOpen,
  getUiStateExportCsvModalOpen,
  getUiStateImportCsvModalOpen,
  getUiStateInspectorModalOpen,
  getUiStateFileVersionTooLowModalOpen,
  getUiStateOpenFileAllowReadonly,
  getUiStateSampleModalOpen,
  getSaveTemplateModalOpen,
  getUiStateNotification,
  getSelectedItems,
  getSelectedMarkers,
  getSelectedSyncItems,
  getSavedFiltersExpanded,
  getSearchReplaceExpanded,
  getSearchCaseSensitive,
  getSearchWholeWord,
  getSearchValue,
  getReplaceValue,
  getExcludedSearchFields,
  getPulsateIconId,
  getMenuPopoverType,
  isModalOpen,
  getFileName,
  getIsEditMode,
  getIsEntityEditMode,
  getDeviceInsets,
  getLeftPanelHasChildPopover,
  getSyncInProgress,
  getSyncProgressLabel,
  getSyncProgressPercent
};
